import React from 'react';

const Logo = ({ width = 151, height = 149, fill = '#fff', ...rest }) => (
  <svg width={width} height={height} viewBox="0 0 151 149" {...rest}>
    <path
      d="M41 19.4c1 4.5.8 8.4-1.1 12.2-1.5 3.2-8.3 10.2-18.7 12.6-10.4 2.4-15.2 2-18.7 2.4-2.5.3-2.9 1.9-2.2 3.1.7 1.3 9.3 9.4 28.4 11.7 14 1.7 12.4 7 15.9 17.2 4.4 12.9 3.8 22.1 3.7 27.4-.1 15.3-1.1 26.7-1.4 30-.8 8.1 4.3 7.6 6-2.4 2.4-15.1 3.1-37.6 3.2-41.9 1.2-21.1 11 7.4 7.1 47.4-.6 5.6-2.2 9-.5 9 2.4 0 4.6-1.8 5.9-5.6 3.7-10.5 4.5-40.8 5-45.8 5.3-32.1 48.6-25.6 51.8 13 1.1 12.9-.6 20.1-2.1 26.5-2.2 7.8 2.9 6.4 4.3 2.4 4-10.9 4.1-19 4.2-21.2.9-22.1-3.6-36.6-3.6-36.6s1.9 2.1 6.1 7.8c12.2 17 2.7 47.7 1.2 52.5-2.8 8.3 3.8 6.8 6.3.1 3.5-9.4 5.1-19 7-36.3 1.2-10.6 1.5-35.7 1.2-41.6-.3-6-1.3-42.7-13.8-56.6-2.6-3-8.2-6.9-7.9-6.4 1.3 2.2 3.1 5.4 4.9 10.9 2.5 7.9 6.2 29.8-13.7 39.3-14.7 7-35.4 7.1-49.3 1.1C56.2 45.4 50.6 37 47 28c-3-8.2-6-8.6-6-8.6z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
);

export default Logo;
